import { render, staticRenderFns } from "./WeekOverviewToggle.vue?vue&type=template&id=4472a6ea&"
import script from "./WeekOverviewToggle.vue?vue&type=script&lang=js&"
export * from "./WeekOverviewToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports